import { useEffect } from "react";

const LoginRedirect = () => {
    useEffect(() => {
        window.location.assign(
            `https://it-dashboard.usbank.com/api/auth/sso/login?userType=usbank&tenantType=fidelity`
        );
    }, [])

    return null;
};

export default LoginRedirect;
